
import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';

import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import * as saveAs from 'file-saver';
import { Config } from 'src/app/app-constant';
import { EncryptionService } from 'src/app/service/encryption/encryption.service';
import { HttpService } from 'src/app/service/http/http.service';
import { SharedService } from 'src/app/service/shared/shared.service';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { NativeDateAdapter } from '@angular/material/core';
import * as XLSX from 'xlsx';
import { MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { DateAdapter } from '@angular/material/core';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { calculateFiscalYear, formatYearRanges } from 'src/app/shared/commen-function-file';

export const MY_DATE_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
}
@Component({
  selector: 'app-asset-management-report',
  templateUrl: './asset-management-report.component.html',
  styleUrls: ['./asset-management-report.component.scss'],
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'en-GB' }, // Use en-GB to get DD/MM/YYYY format
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS },
  ],
})
export class AssetManagementReportComponent implements OnInit {
  allTeamReimbursement: any = [];
  allTeamMemberReimbursementApprove: any = [];
  currentallTeamMemberReimbursementApprove: any = [];
  allListingEmployeeId: any = [];
  allListingEmployeeIdForTeam: any = [];
  currrentTableDataDetails: any = [];
  fitergetAllFinanceUserDDHrAdmin: any = []
  tableDataDetails: any = [];
  selectedEmployeeIdForReport: any;
  dropdownData: any;
  loggedInUserCompanyID: any;
  loggedInCompanyFiscalyear: any | null;
  loggedInUserId: any | null;
  year: any;
  fiscalYear: any;
  buttonColorName: any | null;
  loggedInUserName: any | null;
  loggedInCompanyMDCode: any | null;
  loggedInUserRole: any | null;
  loggedInUserRoles: any;
  loggedInCompanyReviewCycle: any | null;
  loggedInUserRoleIsEmployee: boolean = false;
  authorityNameCheck: any;
  financePerson: any;
  fromYear: any;
  toYear: any;
  selectedTypeTabIndex = 0;
  selectedTypeTabName = 'MyAssetReport'
  isFinanceLoginUser: boolean = false;
  showSetupPopup: boolean = false;
  showImportPopup: boolean = false;
  loggedInCompanyIndustryName: any;
  dropdownSettings: IDropdownSettings = {};
  selectedManagerDashboardId: boolean = false;
  selectedEmployeeDashboardId: any;
  findLogdinUserAsaAuthority: boolean = false;
  constructor(public sharedService: SharedService,
    private encryptionService: EncryptionService, private activatedroute: ActivatedRoute,
    private httpService: HttpService, private config: Config, public router: Router,
    public dialog: MatDialog, private datePipe: DatePipe,
  ) { }

  ngOnInit() {
    this.buttonColorName = sessionStorage.getItem('buttonColorName');
    this.financePerson = sessionStorage.getItem('financeAdminId');
    console.log(this.financePerson);
    this.financePerson = sessionStorage.getItem('financeAdminId');
    console.log('financePerson:', this.financePerson, 'Type:', typeof this.financePerson);

    if (this.financePerson && this.financePerson !== 'undefined' && this.financePerson.trim() !== '') {
      console.log("hello");
      this.isFinanceLoginUser = true;
    } else {
      console.log("Not a valid finance person");
      this.isFinanceLoginUser = false;
    }

    this.loggedInUserCompanyID = Number(this.encryptionService.decryptData(sessionStorage.getItem('loggedInUserCompanyID')));
    this.loggedInCompanyFiscalyear = sessionStorage.getItem('loggedInCompanyFiscalyear');

    if (this.loggedInCompanyFiscalyear) {
      this.loggedInCompanyFiscalyear = this.encryptionService.decryptData(this.loggedInCompanyFiscalyear);
    }
    this.loggedInUserId = sessionStorage.getItem('loggedInUserId');
    this.loggedInUserName = sessionStorage.getItem('loggedInUserName');
    this.loggedInUserRole = sessionStorage.getItem('loggedInUserRole');
    this.loggedInCompanyIndustryName = sessionStorage.getItem('loggedInCompanyIndustryName');
    this.loggedInCompanyMDCode = sessionStorage.getItem('loggedInCompanyMDCode');
    if (this.loggedInUserRole) {
      this.loggedInUserRole = this.encryptionService.decryptData(this.loggedInUserRole);
    }
    this.loggedInUserRoles = JSON.parse(sessionStorage.getItem('loggedInUserRoles') || '[]');
    this.loggedInCompanyReviewCycle = sessionStorage.getItem('loggedInCompanyReviewCycle') || null;


    if (this.loggedInUserRoles.length == 1) {
      for (let i = 0; i < this.loggedInUserRoles?.length; i++) {
        if (this.loggedInUserRoles[i].displayName == "Employee") {
          this.loggedInUserRoleIsEmployee = true
        }
      }
    }

    this.authorityNameCheck = this.httpService.checkAuthorityName;

    this.dropdownSettings = {
      singleSelection: false,
      idField: 'id',
      textField: 'name',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 1,
      allowSearchFilter: true
    };
    this.getpmsyearlist();


  }

  tabTypeChanged(event: MatTabChangeEvent) {

    this.selectedTypeTabName = event.tab.textLabel;
    this.selectedTypeTabIndex = event?.index;
    this.assetAllocationData();
    this.getpmsyearlist();


  }



  downloadExcel(): void {
    // Define explicit headers for the Excel file


    let data;
    data = this.assetAllocationFromAuthority.map((asset: any) => {
      return {
        'Asset Name': asset.assetName,
        'Authority Name': asset.authorityName,
        'Employee Name': asset.employeeName,
        'Band': asset.band,
        'Authority Dept': asset.authorityDepartment,
        'Allocation Date': this.datePipe.transform(asset.dateOfAllocation, 'dd/MM/yyyy') || '',
        'Current Asset Description': asset.currentAssetDescription,
        'Employee Status': asset.employeeAssetStatus,
        'Employee Comment': asset.employeeComment,
        'Employee Comment Date': this.datePipe.transform(asset.employeeCommentDate, 'dd/MM/yyyy') || '',
        'Authority Department Comment': asset.authorityDepartmentComment,
        'Authority Comment Date': this.datePipe.transform(asset.authorityCommentDate, 'dd/MM/yyyy') || '',
        'Asset Repair Time': asset.assetRepairTime,
      };
    });

    const worksheet = XLSX.utils.json_to_sheet(data);

    // Create a workbook and append the sheet
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, `Reimbursements`);

    // Write the workbook to a buffer
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    if (this.loggedInUserRole == 'HR Admin') {

      this.saveAsExcelFile(excelBuffer, `${this.loggedInCompanyIndustryName}-Asset- `);
    }
    else if (this.authorityNameCheck) {
      if (this.selectedTypeTabName == 'MyDeptReport') {

        this.saveAsExcelFile(excelBuffer, `${this.assetAllocationFromAuthority[0]?.authorityName}-Asset-`);
      }
      else {
        this.saveAsExcelFile(excelBuffer, `My Asset`);
      }
    } else if (this.selectedTypeTabName == 'MyAssetReport') {
      this.saveAsExcelFile(excelBuffer, `My Asset`);
    }
  }

  saveAsExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], { type: 'application/octet-stream' });
    const currentDate = new Date();
    const formattedDate = currentDate.toLocaleDateString('en-GB').replace(/\//g, '-'); // Format as dd-mm-yyyy


    saveAs(data, `${fileName}-${formattedDate}.xlsx`);



  }
  taskFromDate: Date | null = null;
  taskToDate: Date | null = null;
  filteredData: any[] = []; // Holds the filtered data


  onDateChangeDashboard(): void {
    this.originalAssets = JSON.parse(JSON.stringify(this.assets));
    this.assets = JSON.parse(JSON.stringify(this.originalAssets));
    if (this.taskFromDate && this.taskToDate) {
      const fromDate = new Date(this.taskFromDate);
      const toDate = new Date(this.taskToDate);

      // Ensure both dates are set to midnight in their respective local time zones
      fromDate.setHours(0, 0, 0, 0);  // Start of the day in local time
      toDate.setHours(23, 59, 59, 999); // End of the day in local time

      // Function to format dates to the desired ISO format with UTC (+00:00)
      const toISOWithUTCOffset = (date: Date): string => {
        const pad = (num: number): string => String(num).padStart(2, '0');
        const year = date.getFullYear();
        const month = pad(date.getMonth() + 1); // Months are zero-based
        const day = pad(date.getDate());

        return `${year}-${month}-${day}`;
      };

      // Format both dates to the start and end of the day in local time
      const formattedFromDate = toISOWithUTCOffset(fromDate);
      const formattedToDate = toISOWithUTCOffset(toDate);

      console.log("Formatted From Date:", formattedFromDate);
      console.log("Formatted To Date:", formattedToDate);

      const filteredData = this.currentassetAllocationFromAuthority.filter((item: any) => {
        const itemDate = new Date(item.dateOfAllocation); // Parse item.date to Date object
        return (
          itemDate >= new Date(formattedFromDate) &&
          itemDate <= new Date(formattedToDate)
        );
      });
      this.assetAllocationFromAuthority = filteredData;
    }
  }
  pmsYears: any = []
  selectedYearForCompetency: any = null;
  // getpmsyearlist() {
  //   this.httpService.callGetService(this.config.getpmsyearlist + this.loggedInUserCompanyID).subscribe((data: any) => {
  //     this.pmsYears = [];

  //     data?.data?.yearRanges?.forEach((ele: any) => {
  //       var test = ele.split('_');
  //       let obj = {
  //         year: test[0] + '-' + test[1]
  //       };

  //       // Get current year
  //       const currentYear = new Date().getFullYear();

  //       // Ensure only past and current years are included
  //       var yearParts = obj.year.split('-');
  //       let fromYear = parseInt(yearParts[0]);
  //       let toYear = parseInt(yearParts[1]);

  //       // Add to pmsYears only if it's not a future year
  //       if (toYear <= currentYear) {
  //         this.pmsYears.push(obj);
  //       }
  //     });

  //     this.pmsYears?.forEach((ele: any) => {
  //       const currentYear = new Date().getFullYear();
  //       let yearValue = '';

  //       // if (this.loggedInCompanyFiscalyear === 'Jan_Dec') {
  //       //   yearValue = `${currentYear}-${currentYear}`;
  //       // } else {
  //       //   yearValue = `${currentYear}-${currentYear + 1}`;
  //       // }
  //       if (this.loggedInCompanyFiscalyear === 'Jan_Dec') {
  //         yearValue = `${currentYear}-${currentYear}`; // Calendar year
  //       } else if (this.loggedInCompanyFiscalyear === 'Apr_Mar') {
  //         if (new Date().getMonth() < 3) {
  //           // If it's Jan, Feb, or Mar, we're in the previous fiscal year
  //           yearValue = `${currentYear - 1}-${currentYear}`;
  //         } else {
  //           // From Apr onwards, it's the current fiscal year
  //           yearValue = `${currentYear}-${currentYear + 1}`;
  //         }
  //       }
  //       if (ele?.year == yearValue) {
  //         this.selectedYearForCompetency = ele?.year;


  //         var test = ele?.year?.split('-');
  //         this.fromYear = test[0];
  //         this.toYear = test[1];
  //       }
  //     });



  //     // Call additional functions if needed
  //     if (this.loggedInUserRole === 'HR Admin' || this.loggedInUserRole === 'Super Admin'
  //       || this.loggedInUserRole === 'PHI Admin' || this.loggedInUserRole === 'MD') {
  //       // Add your logic here
  //     }
  //     this.assetAllocationData();
  //   });

  // }

  getpmsyearlist() {
    this.httpService.callGetService(this.config.getpmsyearlist + this.loggedInUserCompanyID).subscribe((data: any) => {
      this.pmsYears = formatYearRanges(data?.data?.yearRanges);

      const { fiscalStartYear, fiscalEndYear } = calculateFiscalYear(this.loggedInCompanyFiscalyear);

      const yearValue = `${fiscalStartYear}-${fiscalEndYear}`;
      this.setSelectedYear(yearValue);
      this.assetAllocationData();
    });
  }
  setSelectedYear(yearValue: string): void {
    const selectedYearObj = this.pmsYears.find((ele: any) => ele.year === yearValue);
    if (selectedYearObj) {
      this.selectedYearForCompetency = selectedYearObj?.year;
      // this.selectedYearForGraphOneHRAdmin = selectedYearObj?.year;
      // this.selectedYearForGraphTwoHRAdmin = selectedYearObj?.year;
      // this.selectedYearForGraphFifthHRAdmin = selectedYearObj?.year;
      // this.selectedYearForGraphSix = selectedYearObj?.year;
      // this.selectedYearForGraphNineHRAdmin = selectedYearObj?.year;
      // this.selectedYearForGraphTenHRAdmin = selectedYearObj?.year;

      let test = selectedYearObj?.year.split('-');
      this.fromYear = test[0];
      this.toYear = test[1];
    }
  }
  searchTaskString: string = '';



  DislaySelectedRecord(event: any) {
    this.assetAllocationFromAuthority = this.currentassetAllocationFromAuthority.slice(0, event.value);
  }


  changeYear(year: any) {
    this.getDeptList = [];
    this.selectedDep = [];
    this.selectedYearForCompetency = year
    this.assetAllocationData();
  }
  originalAssets: any[] = [];
  currentassetAllocationFromAuthority: any = [];
  assetAllocationFromAuthority: any = [];
  assetAllocationlistForEmployee: any = [];
  employeeDataList: any = [];
  currentEmployeeDataList: any = []
  DropDownData: any = [];
  getDeptList: any = []
  getEmployeeList: any = [];
  fromAuthority: any = []
  assetAllocationData() {
    this.httpService.callGetService(`${this.config.assetAllocation}/${this.loggedInUserCompanyID}/${this.loggedInCompanyFiscalyear}/${this.selectedYearForCompetency}`)
      .subscribe((elm: any) => {


        this.selectedTypeTabName = this.loggedInUserRole == 'HR Admin' ? '' : this.selectedTypeTabName;
        console.log(elm.data);


        this.originalAssets = elm.data.filter((elm: any) => elm.userId != null);
        this.currentassetData = elm.data;
        this.employeeDataList = elm.data.filter((record: any) => record.userId == this.loggedInUserId);
        this.currentEmployeeDataList = elm.data.filter((record: any) => record.userId == this.loggedInUserId);
        this.currentassetAllocationFromAuthority = elm.data.filter((record: any) => record.authorityName == this.loggedInUserName);
        this.fromAuthority = elm.data.filter((record: any) => record.authorityName == this.loggedInUserName && record.userId != null);
        console.log(this.fromAuthority);

        // this.assetAllocationFromAuthority = this.selectedTypeTabName == 'MyDeptReport' ? this.assetAllocationFromAuthority : this.originalAssets;
        this.currentassetAllocationFromAuthority =
          this.selectedTypeTabName === 'MyDeptReport'
            ? this.assetAllocationFromAuthority
            : this.selectedTypeTabName === 'MyAssetReport'
              ? this.employeeDataList
              : this.originalAssets;
        console.log(this.selectedTypeTabName);

        this.assetAllocationFromAuthority =
          this.selectedTypeTabName === 'MyDeptReport'
            ? this.fromAuthority
            : this.selectedTypeTabName === 'MyAssetReport'
              ? this.employeeDataList
              : this.originalAssets;

        console.log(this.assetAllocationFromAuthority);


        this.DropDownData = this.selectedTypeTabName == 'MyDeptReport' ? this.fromAuthority : this.originalAssets;
        this.assetAllocationlistForEmployee = elm.data;



        this.getDeptList = [];
        // this.DropDownData.forEach((ele: any) => {
        //   let obj = {
        //     id: ele.id,
        //     name: ele.authorityDepartment,
        //   }
        //   this.getDeptList.push(obj);

        // });

        this.getDeptList = [];
        const uniqueNames = new Set();

        this.DropDownData.forEach((ele: any) => {
          const name = ele.authorityDepartment?.trim(); // Ensure name is trimmed and consistent
          if (name && !uniqueNames.has(name)) { // Check if the name is not already added
            uniqueNames.add(name); // Add name to the Set
            this.getDeptList.push({
              id: ele.id,
              name: name,
            });
          }
        });



        this.getDateByEmployeeName();


      })

  }
  assets: any = [];
  currentassetData: any = [];

  deleteasset(id: any) {
    this.httpService.callDeleteService(`${this.config.deleteAssetFromEmployee}/${id}`)
      .subscribe((elm: any) => {
        console.log(elm);

      })

  }

  //----------------------------------------------------------------------- Single Authority User----------------------------------------------------------------------------------------------


  AllAssetListingData: any;

  getAllaseetListingData() {
    this.httpService.callGetService(`${this.config.getAssetListingAll}/${this.loggedInUserCompanyID}/${this.loggedInCompanyFiscalyear}/${this.selectedYearForCompetency}`)
      .subscribe((elm: any) => {
        this.AllAssetListingData = elm.data;
        console.log(elm);


      })

  }


  checkDataForAuthority() {

    console.log(this.loggedInUserId);

    const filterEployeeId = this.AllAssetListingData.filter((record: any) => record.userId == this.loggedInUserId);
    console.log(filterEployeeId.length);

    if (filterEployeeId.length > 0) {
      this.findLogdinUserAsaAuthority = true;
    }

  }



  // ------------------------------------------------------------------------------My Asset -----------------------------------------------------------------------------------------------------
  allocatingAssetEmployee: any = [];

  allocatingEmployee: any = [];
  assetOptions = [
    "RECEIVED_ASSET",
    "REPAIR_ASSET",
    "RETURNING ASSET DUE TO EXIT",
    "RECEIVED AFTER REPAIR"
  ];
  updateAssetData(event: any) {

  }
  getDateByEmployeeName() {
    console.log(this.assetAllocationlistForEmployee);

    console.log(this.loggedInUserId);

    this.allocatingAssetEmployee = this.assetAllocationlistForEmployee.filter((record: any) => record.userId == this.loggedInUserId);
    console.log(this.allocatingAssetEmployee);

    const assetMap = new Map<string, any>();

    // Loop through the original assets and group by asset name
    for (const asset of this.allocatingAssetEmployee) {
      if (assetMap.has(asset.assetName)) {
        // If asset name already exists, merge the users
        const existingAsset = assetMap.get(asset.assetName);
        existingAsset.users.push({
          id: asset.id,
          assetName: asset.assetName,
          bands: asset.bands,
          band: asset.band,
          assetId: asset.assetId,
          userId: asset.userId,
          employeeName: asset.employeeName,
          employeeComment: asset.employeeComment,
          currentAssetDescription: asset.currentAssetDescription,
          authorityDepartmentComment: asset.authorityDepartmentComment,
          // Corrected property name
          assetRepairTime: asset.assetRepairTime,
          employeeAssetStatus: asset.employeeAssetStatus,
          employeeCommentDate: asset.employeeCommentDate,
          dateOfAllocation: asset.dateOfAllocation,
          allocatingAuthorityName: asset.authorityName,
          authorityDepartment: asset.authorityDepartment,
          authorityCommentDate: asset.authorityCommentDate
        });
      } else {
        // If asset name doesn't exist, add it to the map
        assetMap.set(asset.assetName, {
          assetName: asset.assetName,
          bands: asset.bands,
          dateOfAllocation: asset.dateOfAllocation,
          allocatingAuthorityName: asset.authorityName,
          isExpand: false,
          id: asset.id,
          users: [{
            id: asset.id,
            assetName: asset.assetName,
            bands: asset.bands,
            band: asset.band,
            userId: asset.userId,
            assetId: asset.assetId,
            employeeName: asset.employeeName,
            employeeComment: asset.employeeComment,
            currentAssetDescription: asset.currentAssetDescription,
            authorityDepartmentComment: asset.authorityDepartmentComment,
            // Corrected property name
            assetRepairTime: asset.assetRepairTime,
            employeeAssetStatus: asset.employeeAssetStatus,
            employeeCommentDate: asset.employeeCommentDate,
            dateOfAllocation: asset.dateOfAllocation,
            allocatingAuthorityName: asset.authorityName,
            authorityDepartment: asset.authorityDepartment,
            authorityCommentDate: asset.authorityCommentDate
          }]
        });
      }
    }

    // Convert the map to an array
    this.allocatingEmployee = Array.from(assetMap.values());

    console.log(this.allocatingEmployee);

  }

  nestedHeaders = [
    { sortingName: 'assetName', label: 'Asset Name' },
    { sortingName: 'employeeName', label: 'Employee Name' },
    { sortingName: 'band', label: 'Band' },
    { sortingName: 'authorityDepartment', label: 'Authority Dept' },
    { sortingName: 'authorityName', label: 'Authority Name' },
    { sortingName: 'dateOfAllocation', label: 'Allocation Date' },
    { sortingName: 'currentAssetDescription', label: 'Current Asset Description' },
    { sortingName: 'employeeAssetStatus', label: 'Employee Status' },
    { sortingName: 'employeeComment', label: 'Employee Comment' },
    { sortingName: 'employeeCommentDate', label: 'Employee Comment Date' },
    { sortingName: 'authorityDepartmentComment', label: 'Authority Department Comment' },
    { sortingName: 'authorityCommentDate', label: 'Authority Comment Date' },
    { sortingName: 'assetRepairTime', label: 'Asset Repair Time' },

  ];

  ngOnChanges() {
    console.log("hdfgj");

    // Re-filter assets if the data changes
  }
  filteredAssets: any = []
  searchTerm: string = '';
  filterAssets(searchTerm: string) {
    console.log(searchTerm);

    // Reset to original data if the search term is empty
    if (!searchTerm.trim()) {
      this.resetAssets();
      return;
    }

    // Normalize the search term
    const normalizedSearchTerm = searchTerm.trim().toLowerCase();

    // Define a generic filter function
    const filterBySearchTerm = (searchKey: any[]) =>
      searchKey.filter((asset: any) =>
        (asset.assetName?.toLowerCase().includes(normalizedSearchTerm)) ||
        (asset.employeeName?.toLowerCase().includes(normalizedSearchTerm)) ||
        (asset.band?.toLowerCase().includes(normalizedSearchTerm)) ||
        (asset.authorityDepartment?.toLowerCase().includes(normalizedSearchTerm)) ||
        (asset.authorityName?.toLowerCase().includes(normalizedSearchTerm)) ||
        (asset.dateOfAllocation?.toLowerCase().includes(normalizedSearchTerm)) ||
        (asset.employeeAssetStatus?.toLowerCase().includes(normalizedSearchTerm)) ||
        (asset.employeeCommentDate?.toLowerCase().includes(normalizedSearchTerm)) ||
        (asset.authorityDepartmentComment?.toLowerCase().includes(normalizedSearchTerm)) ||
        (asset.authorityCommentDate?.toLowerCase().includes(normalizedSearchTerm))
      );



    this.filteredAssets = filterBySearchTerm(this.currentassetAllocationFromAuthority);
    this.assetAllocationFromAuthority = [...this.filteredAssets];
  }

  // Helper method to reset assets to their original state
  private resetAssets() {
    // this.assetAllocationData(); // Reset or fetch the original data
    this.assetAllocationFromAuthority = [...this.currentassetAllocationFromAuthority]; // Restore to the original assets
  }




  sortOrder: { [key: string]: 'asc' | 'desc' } = {}; // Track sort order for each key
  onSortAssending(sortKey: any): void {
    this.sortOrder[sortKey] = this.sortOrder[sortKey] === 'asc' ? 'desc' : 'asc';

    this.assetAllocationFromAuthority.sort((a: any, b: any) => {
      if (a[sortKey] > b[sortKey]) return this.sortOrder[sortKey] === 'asc' ? -1 : 1;
      if (a[sortKey] < b[sortKey]) return this.sortOrder[sortKey] === 'asc' ? 1 : -1;
      return 0;
    });

  }
  onSortDesending(sortKey: any): void {
    this.sortOrder[sortKey] = this.sortOrder[sortKey] === 'asc' ? 'desc' : 'asc';
    this.assetAllocationFromAuthority.sort((a: any, b: any) => {
      if (a[sortKey] < b[sortKey]) return this.sortOrder[sortKey] === 'asc' ? -1 : 1;
      if (a[sortKey] > b[sortKey]) return this.sortOrder[sortKey] === 'asc' ? 1 : -1;
      return 0;
    });
  }

  selectedEmployee: any = [];
  selectedEmployeRecord(event: any) {

  }

  fiterDataForDep() {

    if (this.selectedDep.length > 0) {

      const deptID = this.selectedDep.map((elm: any) => elm.name);


      this.assetAllocationFromAuthority = this.DropDownData.filter((record: any) => deptID.includes(record.authorityDepartment));
      // this.getEmployeeList = [];
      // this.assetAllocationFromAuthority.forEach((ele: any) => {
      //   let obj = {
      //     id: ele.userId,
      //     name: ele.employeeName,
      //     deptId: ele.id
      //   }
      //   this.getEmployeeList.push(obj);

      // });
      this.currentassetAllocationFromAuthority = this.assetAllocationFromAuthority;
      this.getEmployeeList = [];
      const uniqueNames = new Set();

      this.assetAllocationFromAuthority.forEach((ele: any) => {
        const name = ele.employeeName?.trim(); // Ensure name is consistent and trimmed
        if (name && !uniqueNames.has(name)) { // Check if the name is not already added
          uniqueNames.add(name); // Add name to the Set
          const obj = {
            id: ele.userId,
            name: name,
            deptId: ele.id
          };
          this.getEmployeeList.push(obj);
        }
      });

    }

    else {
      this.clearSelections();

      this.assetAllocationFromAuthority = this.DropDownData;

    }


  }
  getBandList: any = [];
  fiterDataForEmployee() {

    if (this.selectedEmployee.length > 0) {



      const deptID = this.selectedDep.map((elm: any) => elm.name);
      const employeeID = this.selectedEmployee.map((elm: any) => elm.id);

      this.assetAllocationFromAuthority = this.DropDownData.filter((record: any) => employeeID.includes(record.userId) && deptID.includes(record.authorityDepartment));
      this.currentassetAllocationFromAuthority = this.assetAllocationFromAuthority;
      this.getBandList = [];
      let emptyBand: any = []
      this.assetAllocationFromAuthority.forEach((ele: any, index: any) => {
        let obj = {
          id: index,
          name: ele.band,

        }
        emptyBand.push(obj);

      });
      console.log(emptyBand);

      emptyBand.map((elm: any) => {
        if (!this.getBandList.some((e: any) => e.name == elm.name)) {
          this.getBandList.push(elm)
        }
      })
    }
    else {


      this.selectedBand = [];
      this.selectedEmployee = [];
      this.getBandList = [];
      const deptID = this.selectedDep.map((elm: any) => elm.name);
      this.assetAllocationFromAuthority = this.DropDownData.filter((record: any) => deptID.includes(record.authorityDepartment));

    }


  }

  clearSelections() {

    this.selectedEmployee = [];
    this.selectedDep = [];
    this.selectedBand = [];
    this.getEmployeeList = [];
    this.getBandList = [];
  }

  // ---------------------------------------------------------------------------------For  Employee------------------------------------------------------------------
  onSelectEmployee() {



    // Ensure selectedDepartment is an array and has selected items
    if (this.selectedEmployee && this.selectedEmployee.length > 0) {
      this.fiterDataForEmployee();

    } else {
      this.clearSelections(); // Clear selections if no department is selected
    }
  }

  onDeSelectEmployee() {

    this.fiterDataForEmployee();
  }

  SelectALLEmployee(items: any): void {

    this.selectedEmployee = items;
    this.fiterDataForEmployee();

  }


  onDeSelectALLEmployee() {
    this.selectedEmployee = [];
    this.selectedBand = [];
    this.getBandList = [];
  }

  // ---------------------------------------------for Depart Ment-------------------------------------------------
  selectedDep: any = [];
  onSelectDepartment() {
    // Ensure selectedDepartment is an array and has selected items
    if (this.selectedDep && this.selectedDep.length > 0) {
      this.fiterDataForDep();
    } else {
      this.clearSelections(); // Clear selections if no department is selected
    }
  }

  onDeSelectDepartment() {
    this.selectedDep = [];
    this.fiterDataForDep();
  }

  selectAllDepartment(items: any): void {
    this.selectedDep = items; // Select all departments
    this.fiterDataForDep();

  }


  onDeSelectAllDepartment() {
    this.selectedDep = [];
    this.selectedEmployee = [];
    this.getEmployeeList = [];
    this.assetAllocationData()

  }

  // ---------------------------------------------------------------------For Band-------------------------------------------------------

  selectedBand: any[] = [];
  filterDataForBand() {
    if (this.selectedBand.length > 0) {
      const employeeID = this.selectedEmployee.map((elm: any) => elm.id);
      const band = this.selectedBand.map((elm: any) => elm.name);
      const deptID = this.selectedDep.map((elm: any) => elm.name);
      this.assetAllocationFromAuthority = this.DropDownData.filter((record: any) => band.includes(record.band) && employeeID.includes(record.userId) && deptID.includes(record.authorityDepartment));
      this.currentassetAllocationFromAuthority = this.assetAllocationFromAuthority;

    } else {
      const employeeID = this.selectedEmployee.map((elm: any) => elm.id);
      const deptID = this.selectedDep.map((elm: any) => elm.name);
      this.assetAllocationFromAuthority = this.DropDownData.filter((record: any) => employeeID.includes(record.userId) && deptID.includes(record.authorityDepartment));

    }
  }

  onSelectBand() {

    // Ensure selectedBand is an array and has selected items
    if (this.selectedBand && this.selectedBand.length > 0) {

      this.filterDataForBand(); // Filter data based on the selected bands
    } else {

      this.clearSelections(); // Clear selections if no band is selected
    }
  }

  onDeSelectBand() {

    this.filterDataForBand(); // Filter data with empty selection
  }

  selectAllBands(items: any): void {
    this.selectedBand = items;
    this.filterDataForBand();
  }

  onDeSelectAllBands() {
    this.selectedBand = [];
    this.selectedEmployee = []
    this.assetAllocationData()
  }

} 
